import Vue from 'vue'

Vue.directive('has-permission', {
  inserted: function (el, binding) {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
    const requiredPermission = binding.value
    
    if (!permissions.includes(requiredPermission)) {
      el.style.display = 'none'
      setTimeout(() => {
        if (el.parentNode) {
          el.parentNode.removeChild(el)
        }
      }, 0)
    }
  }
})

export default Vue